import {FACTIONS} from '../constants/factions';
import {FINAL_ROUND} from './game';

/**
 * Первый бой новичка — локальная партия против ботов.
 *
 * Сюда игрок попадает с поздравления за последнюю главу обучения (кнопка
 * «В битву») и с приглашения в главном меню (BotMatchPromoModal): состав
 * собран заранее, чтобы новичку не пришлось ничего настраивать — ни поля,
 * ни фракций, ни числа раундов.
 *
 * Фракции подобраны под уроки: орки — награда за последнюю главу обучения,
 * то есть игрок идет в бой за только что открытую фракцию, а соперники
 * берут доступные всем Вентори и Гномов. Бонусов у ботов нет — новичок
 * играет на равных.
 */
export const NEWBIE_BATTLE_FIELD_ID = 'field_players_3_alt_3';

export const NEWBIE_BATTLE_PLAYER_FACTION_ID = FACTIONS.ORCS;

// Порядок соперников — порядок цветов поля после живого игрока
export const NEWBIE_BATTLE_BOT_FACTION_IDS = [FACTIONS.VENTORY, FACTIONS.DWARVES];

export const NEWBIE_BATTLE_ROUND_COUNT = FINAL_ROUND;
